module.exports = __webpack_public_path__ + "img/mrt.86ad5b80.png";